import { motion } from "framer-motion";
import { ArrowRight, Clock } from "lucide-react";
import { useHome } from "@/context/HomeContent";
import { mediaUrl, normalizeHref } from "@/lib/api";
import { fadeUp, staggerParent, viewportOnce } from "@/lib/animations";

const Featured = () => {
  const { home } = useHome();
  const d = home.featured;
  return (
    <section id="featured" data-testid="featured-section" className="bg-brand-cream py-24 sm:py-32">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <motion.div variants={staggerParent} initial="hidden" whileInView="show" viewport={viewportOnce} className="max-w-2xl">
          <motion.p variants={fadeUp} className="mb-5 font-heading text-xs font-bold uppercase tracking-[0.22em] text-brand-magenta">{d.eyebrow}</motion.p>
          <motion.h2 variants={fadeUp} className="font-heading text-4xl font-semibold leading-[1.05] tracking-tight text-brand-ink sm:text-5xl lg:text-[3.4rem]">
            {d.headingLead}{" "}
            <span className="brand-gradient-text">{d.headingAccent}</span>
          </motion.h2>
        </motion.div>

        <motion.div variants={staggerParent} initial="hidden" whileInView="show" viewport={viewportOnce} className="mt-14 grid grid-cols-1 gap-7 sm:grid-cols-2 lg:grid-cols-3">
          {(d.items || []).map((p, i) => (
            <motion.article key={i} variants={fadeUp} data-testid={`featured-card-${i}`} className={`group flex flex-col overflow-hidden rounded-[24px] border border-brand-line bg-white ${i % 3 === 1 ? "lg:mt-10" : ""}`}>
              <div className="relative h-64 overflow-hidden">
                <img src={mediaUrl(p.image)} alt={p.name} className="h-full w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-110" />
                <span className="absolute left-4 top-4 rounded-full bg-brand-ink/70 px-3 py-1 font-heading text-[11px] font-semibold uppercase tracking-wider text-white backdrop-blur">{p.tag}</span>
              </div>
              <div className="flex flex-1 flex-col p-7">
                <h3 className="font-heading text-2xl font-semibold text-brand-ink">{p.name}</h3>
                <p className="mt-3 flex-1 font-body text-[15px] leading-relaxed text-brand-ink/65">{p.desc}</p>
                <div className="mt-6 flex items-center justify-between border-t border-brand-line pt-5">
                  <span className="inline-flex items-center gap-1.5 font-body text-sm text-brand-ink/55">
                    <Clock className="h-4 w-4 text-brand-magenta" />
                    {p.duration}
                  </span>
                  <a href={normalizeHref(p.learnHref) || "#contact"} data-testid={`featured-learn-more-${i}`} className="group/lm inline-flex items-center gap-1.5 font-heading text-sm font-semibold text-brand-ink transition-colors duration-300 hover:text-brand-magenta">
                    {p.learnLabel || "Learn More"}
                    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover/lm:translate-x-1" />
                  </a>
                </div>
              </div>
            </motion.article>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Featured;
